import { render } from "./CheckoutBehindCurtains.vue?vue&type=template&id=31bac4db"
import script from "./CheckoutBehindCurtains.vue?vue&type=script&lang=js"
export * from "./CheckoutBehindCurtains.vue?vue&type=script&lang=js"

import "./CheckoutBehindCurtains.vue?vue&type=style&index=0&id=31bac4db&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__